import { useLocation } from "react-router-dom"
import { FaEdit } from "react-icons/fa";
import BasicDataTable from "../../../../../Component/BasicComponents/BasicDataTable";
import { useOutletDCRSummary, useOutletRcpaSummary, useOutletSgpiOutSummary } from "../../hooks/useCustomer";
import { useState } from "react";


const TableColumns = () => [
  {
    name: "Outlet Name",
    selector: (row: { OutletName: string }) => row.OutletName||"-",
    sortable:true
  },
  {
    name: "Brand Name",
    selector: (row: { BrandName: string }) => row.BrandName||"-",
    sortable:true

  },
  {
    name: "Outlet Classification",
    selector: (row: { OutletClassification: any }) => row.OutletClassification||"-",
    sortable:true,
    minWidth:'150px'
  },
  {
    name: "Territory Name",
    selector: (row: { TerritoryName: any }) => row.TerritoryName||"-",
    sortable:true,wrap:true

  },
  {
    name: "Org Unit Name",
    selector: (row: { OrgUnitName: any }) => row.OrgUnitName||"-",
    sortable:true,

    wrap: true,
  },
   {
    name: "Tags",
    selector: (row: { Tags: string }) => row.Tags||"-",
    sortable:true

  },
  {
    name: "Visit FQ",
    selector: (row: { VisitFq: string }) => row.VisitFq||"-",
    sortable:true

  },
  {
    name: "RCPA Moye",
    selector: (row: { RcpaMoye: string }) => row.RcpaMoye||"-",
    sortable:true

  },
  {
    name: "Last Create",
    selector: (row: { LastCreated: string }) => row.LastCreated||"-",
    sortable:true

  },
];

const RcpaSummaryTable=({OutletOrgId}:any)=>{

    console.log('sgpiOut mai',OutletOrgId)
     const [pageState, setPageState] = useState({
     page: 1,
   });
   const [limitState, setLimitState] = useState({
     limit: 10,
   });
   const [search,setSearch]=useState({
     searchValue:null
   })


    const{data:SgpiOutData}=useOutletRcpaSummary({
        enabled:!!OutletOrgId,
        id:OutletOrgId,
        params:{
            page:pageState.page,
            limit:limitState.limit,
            search:search.searchValue
        }
    })


const formateTableData = () =>
  (SgpiOutData?.data?.RCPASummaryData || []).map((key: any) => ({
    OutletName: key.OutletName,
    BrandName: key.BrandName||"",
    OutletClassification: key.ClassificationName||"",
    TerritoryName: key.TerritoryName,
    OrgUnitName: key.OrgUnitName,
    Tags: key.Tags,
    VisitFq: key.VisitFq,
    RcpaMoye: key.RcpaMoye,
    LastCreated: key.Lastcreated,
  }));




const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
 
      };
  });
      setLimitState((prevState: any) => {
        return {
          ...prevState,
          limit: limit,
        };
      });
    
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  }

   const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  }


return(
    <div>
<BasicDataTable
paginationTotalRows={SgpiOutData?.data?.Pagination.TotalRCPASummary}
columns={TableColumns()}
data={formateTableData()||[]}
Title="RCPA Summary"
onChangePage={(pageNo: number) => {
             handlePagination(pageNo);
           }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
           handleonChangeRowsPerPage(newPerPage, page);
         }}
            handleSearch={(val: any) => {
          handleSearch(val);
        }}
/>
    </div>
)
}
export default RcpaSummaryTable